import React from 'react';
import ApplicationStore from 'stores/ApplicationStore';
import pt from './pt';
import en from './en';
import es from './es';

/**
 * i18n leve do checkout (sem lib). Ativado só quando o embed/URL traz ?lang=en|es
 * (propagado pela meta `lang` do carrinho); sem parâmetro tudo permanece em pt.
 *
 * - t() deve ser chamado dentro do render() de componentes @observer: o deref de
 *   ApplicationStore.lang é o que cria a reatividade (mobx). Fora de render é snapshot.
 * - Os dicionários são objetos simples (não-observables), um arquivo por idioma,
 *   chaves flat por área (payment.*, checkout.*, validation.*...). pt é a fonte da verdade.
 * - Cuidado: imports de 'moment/locale/*' têm efeito colateral global; quem renderiza data
 *   na jornada deve garantir ApplicationStore.syncMomentLocale() (os widgets e o Checkout fazem).
 */

const dicts = { pt, en, es };

export const LANGS = ['pt', 'en', 'es'];

// 'en-US' -> 'en', 'ES_mx' -> 'es'; inválido -> null
export function normalizeLang(raw) {
    if (typeof raw !== 'string') return null;
    const base = raw.toLowerCase().split(/[-_]/)[0];
    return LANGS.indexOf(base) !== -1 ? base : null;
}

export function t(key, params) {
    const lang = ApplicationStore.lang;
    const dict = dicts[lang] || dicts.pt;
    let text = dict[key] !== undefined ? dict[key] : dicts.pt[key];
    if (text === undefined) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('[i18n] chave ausente: ' + key);
        }
        return key;
    }
    if (params) {
        Object.keys(params).forEach(name => {
            text = text.split('{' + name + '}').join(params[name]);
        });
    }
    return text;
}

// Telefone internacional: quando o checkout está em idioma estrangeiro, os campos de
// telefone abandonam a máscara BR ("99 999999999") e aceitam formato livre com DDI.
export const INTL_PHONE_RE = /^\+?[\d\s().-]{8,20}$/;
export function isIntlPhone() {
    return ApplicationStore.lang !== 'pt';
}

// Para frases com JSX no meio (links etc.): tx('x', { link: <a .../> }) -> array de nós
export function tx(key, params) {
    const raw = t(key);
    const parts = raw.split(/(\{[a-zA-Z0-9_]+\})/g);
    return parts.map((part, i) => {
        const m = part.match(/^\{([a-zA-Z0-9_]+)\}$/);
        if (m && params && params[m[1]] !== undefined) {
            return React.createElement(React.Fragment, { key: i }, params[m[1]]);
        }
        return part;
    });
}
